package com.snakesworld.game.network

import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

/**
 * Local/test stand-in for a player id when Firebase Auth is not available
 * ([LocalMultiplayerRepository]). Production identity is always the Firebase Auth uid.
 */
@OptIn(ExperimentalUuidApi::class)
fun newUserId(): String = Uuid.random().toString()

/** Legacy offline / placeholder ids that must not be persisted as real account keys. */
fun isEphemeralUserId(userId: String): Boolean =
    userId.isBlank() ||
        userId.startsWith("pilot_") ||
        userId.startsWith("test_pilot_") ||
        userId.startsWith("offline_")
